import { IDs } from '../../../helpers/IDs';
import { DataService } from '../../../services/data_service';

const dataService = new DataService();

export function setB5Vorjahresdaten(formData: any, field: any, propsData: any) {
    const vorjahrKeys: string[] = [
        'vorjahr_flaeche_nutzung', 'vorjahr_flaeche_versiegelt', 'vorjahr_flaeche_naturnah_standort', 'vorjahr_flaeche_naturnah_ausserhalb'
    ];
    if (vorjahrKeys.indexOf(`vor${field.key}`) !== -1) {
        if (Array.isArray(propsData[IDs.ENT_VSME_B5]) && propsData[IDs.ENT_VSME_B5].length > 0) {
            const nextFnd = propsData[IDs.ENT_VSME_B5].find((r: any) => r.jahr === formData.jahr + 1);
            if (nextFnd) {
                const nextData = { tid: nextFnd.tid, [`vor${field.key}`]: formData[field.key] }
                dataService.setData(IDs.MOD_ETOOL, IDs.ENT_VSME_B5, nextData);
            }
        }
    }
}
